import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { motion } from 'framer-motion';
import { ArrowRightLeft } from 'lucide-react';

const ERC20Node = ({ id, data }) => {
  const { address, parent, onUpdate } = data;

  return (
    <motion.div
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className="bg-slate-800 rounded-xl border-2 border-orange-500/50 shadow-xl min-w-[320px]"
    >
      {/* Header */}
      <div className="bg-gradient-to-r from-orange-500 to-red-600 rounded-t-lg px-4 py-3">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-white/20 flex items-center justify-center">
            <ArrowRightLeft className="w-5 h-5 text-white" />
          </div>
          <div>
            <h3 className="font-semibold text-white text-sm">ERC-20 Mapping</h3>
            <p className="text-white/70 text-xs">Ethereum token bridge</p>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="p-4 space-y-3">
        <div>
          <label className="block text-xs font-medium text-slate-400 mb-1.5">
            Contract Address
          </label>
          <input
            type="text"
            value={address || ''}
            onChange={(e) => onUpdate?.({ address: e.target.value })}
            placeholder="0x..."
            className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm font-mono placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-orange-500/50 focus:border-orange-500"
          />
          <p className="text-xs text-slate-500 mt-1">ERC-20 contract address on Ethereum</p>
        </div>

        <div>
          <label className="block text-xs font-medium text-slate-400 mb-1.5">
            Parent System
          </label>
          <select
            value={parent || 'vETH'}
            onChange={(e) => onUpdate?.({ parent: e.target.value })}
            className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:ring-2 focus:ring-orange-500/50"
          >
            <option value="vETH">vETH (Ethereum)</option>
          </select>
        </div>

        {address && (
          <div className="p-2 bg-orange-500/10 rounded-lg border border-orange-500/20">
            <p className="text-xs text-orange-400 font-mono break-all">
              {`nativecurrencyid: {"type": 9, "address": "${address}"}`}
            </p>
          </div>
        )}

        <div className="flex items-center gap-2 p-2 bg-slate-900/50 rounded-lg">
          <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
          <p className="text-xs text-slate-400">
            Will use ETH Notarization (proofprotocol: 3)
          </p>
        </div>
      </div>

      {/* Handle */}
      <Handle
        type="source"
        position={Position.Right}
        className="!w-3 !h-3 !bg-orange-500 !border-2 !border-slate-800"
      />
    </motion.div>
  );
};

export default ERC20Node;
